import Rotate90DegreesCcwRounded from '@mui/icons-material/Rotate90DegreesCcwRounded';
import { Box, IconButton, SxProps, Tooltip } from '@mui/material';
import React, { FC } from 'react';

import { tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';

interface IRotate90DegreesIconProps {
  onClick?: () => void;
}

const Rotate90DegreesIcon: FC<IRotate90DegreesIconProps> = ({ onClick }) => {
  return (
    <Tooltip title={tooltips.Rotate90Degrees} arrow>
      <Box component="span">
        <IconButton onClick={onClick} sx={{ ...CommonStyles, ...sxMR0 } as SxProps}>
          <Rotate90DegreesCcwRounded sx={StyledIcon()} />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export { Rotate90DegreesIcon };
